import * as React from "react"
import { useSignal } from "@preact/signals-react"
import { TextField, Typography, Box } from "@mui/material"
import { ModalSeeker, IconSeeker } from "@ui-seeker/core"

import { renderSkuGroup, isOpenSkuGroupModal } from "@signals"
import { useSkuGroupModal } from "@hooks"
import GroupsTable from "./GroupTable"


export default function DIPSkuGroupModal({ data, ...props }) {

    const { skuGroupData, insertSkuGroup } = useSkuGroupModal()

    const skuGroupName = useSignal('')

    const handleClick = () => {
        if (skuGroupName.value.length) {
            renderSkuGroup.value = false
            insertSkuGroup(skuGroupName.value)
        }
    }

    const modalConfig = {
        title: "SKU Group Management",
        isOpen: isOpenSkuGroupModal.value,
        successText: 'Save',
        containerProps: { maxWidth: 'sm' },
        controller: () => {
            isOpenSkuGroupModal.value = false
            skuGroupName.value = ""
        },
        successProps: {
            onClick: handleClick,
            disabled: !skuGroupName.value
        },
        ...props
    }
    
    return <ModalSeeker {...modalConfig}>
        <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', mt: 3 }}>
            <TextField 
                placeholder="Insert new Sku Group name"
                value={skuGroupName.value}
                onChange={e => skuGroupName.value = e.target.value}
                sx={{ width: 500 }}
            />
            { !!skuGroupData.value?.length ? <GroupsTable /> : <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', mt: 4, mb: 2, px: 4, py: 3, borderRadius: 2, bgcolor: 'grey.50', width: 500 }}>
                <IconSeeker icon='thumbs-down' iconWeight='regular' color='info.light' sx={{ fontSize: '2.5rem', mb: 1.5 }} />
                <Typography variant='subtitle2' sx={{ color: 'text.primary', mb: 0.5 }}>No personal SKU Groups found</Typography>
                <Typography variant='caption' sx={{ color: 'text.secondary', textAlign: 'center' }}>Groups shared across your organisation may still be available in the selector.</Typography>
            </Box> }
        </Box>
    </ModalSeeker>
}